module.exports = __webpack_public_path__ + "img/VA.6182350f.svg";